module.exports = __webpack_public_path__ + "static/media/new.fa123e64.svg";